import { motion } from 'framer-motion';
import { CalendarBlank } from '@phosphor-icons/react';
import AppLayout from '@/components/AppLayout';
import BackButton from '@/components/BackButton';

export default function Calendar() {
  return (
    <AppLayout>
      <div className="p-8" data-testid="calendar-page">
        {/* Back Button */}
        <BackButton to="/dashboard" label="Retour au tableau de bord" className="mb-4" />
        
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          className="mb-8"
        >
          <h1 className="text-4xl font-bold mb-2">Calendrier</h1>
          <p className="text-muted-foreground">Planifiez et organisez votre contenu</p>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="glass rounded-xl p-12 text-center min-h-[500px] flex flex-col items-center justify-center"
        >
          <CalendarBlank size={64} weight="duotone" className="text-primary mb-6" />
          <h2 className="text-2xl font-bold mb-4">Calendrier de planification</h2>
          <p className="text-muted-foreground max-w-md mb-6">
            Organisez votre stratégie de contenu avec notre calendrier interactif.
            Planifiez vos publications à l'avance pour une présence en ligne cohérente.
          </p>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10 text-primary text-sm">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
            Disponible prochainement
          </div>
        </motion.div>
      </div>
    </AppLayout>
  );
}
